module.exports = __webpack_public_path__ + "img/west-1-director.c7618485.png";